import { ImageAttributes } from "../types/Image";

export const getAltLabel = (imageAttributes: ImageAttributes) => {
  if (imageAttributes.alternativeText) return imageAttributes.alternativeText;
  if (imageAttributes.caption) return imageAttributes.caption;
  else return imageAttributes.name;
};
